module.exports = __webpack_public_path__ + "img/黑桃初级大师@2x.e0a7d0b1.png";